import { Component, OnInit, Inject } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatDialogConfig} from '@angular/material/dialog';
import { Router} from "@angular/router";

let moment = require('moment');

@Component({
    selector: 'app-show-graph-results',
    templateUrl: './show-graph-results.component.html',
    styleUrls: ['./show-graph-results.component.css'],
    standalone: false
})
export class ShowGraphResultsComponent implements OnInit {

  dataFromCaller = null;
  contractData = [];
  nameOfDrillDown = 'No Name Given.';
  graphId = null;

  private gridApi;

  defaultColDef = {
    resizable: true,
    sortable: true,
    filter: true
  };

  contractColumns = [
    {headerName: 'Contract Name', field: 'nameOfContract', width: 125 },
    {headerName: 'Effective Date', field: 'effectiveDate', width: 50,
        cellRenderer: this.dateFormatter },
    {headerName: 'Expiration Date', field: 'expirationDate', width: 50,
        cellRenderer: this.dateFormatter },
  ];

  baaColumns = [
    {headerName: 'Covered Entity Name', field: 'coveredEntityName', width: 125 },
    {headerName: 'Effective Date', field: 'effectiveDate', width: 50,
        cellRenderer: this.dateFormatter },
    {headerName: 'Description', field: 'description', width: 100 }
  ];


  constructor(@Inject(MAT_DIALOG_DATA) data,
              public router: Router) {

    console.log('data from contract list: ', data);
    console.log('data name: ', data.name);
    console.log('graphId: ', data.graphId);
    this.contractData = data.contractData;
    this.nameOfDrillDown = data.name;
    this.graphId = data.graphId;
  }


  ngOnInit() {
    console.log('contract data: ', this.contractData);
  }


  onContractCellClicked(event: any) {
    console.log('Contract cell clicked: ', event);
    this.router.navigate(['/securehome/contract', event.data.contractNum]);
  }

  onBaaCellClicked(event: any) {
    console.log('BAA cell clicked: ', event);
    this.router.navigate(['/securehome/baa', event.data.baaNum]);
  }

  onGridReady(params) {
    this.gridApi = params.api;
    //this.gridColumnApi = params.columnApi;
    this.gridApi.sizeColumnsToFit();
  }

  dateFormatter(params) {

    console.log('processing date: ', params.value);

    if (params.value === undefined) {
      return 'none';
    } else {
      var dateObject = moment(params.value);
      var friendlyDate = dateObject.format('ll');

      return friendlyDate;
    }
  }

}
